// Same rule as core-model Statuses (web spec §7.3), checked by the shared cases (SW-WS-22).
export type RestrictionStatus = "SCHEDULED" | "ACTIVE" | "ENDED" | "DISABLED";

export interface Timed {
  startAt?: string;
  endAt?: string;
  enabled?: boolean;
}

export interface EventPeriod {
  startAt: string;
  endAt: string;
}

export function status(r: Timed, e: EventPeriod, t: Date): RestrictionStatus {
  if (r.enabled === false) return "DISABLED";
  const end = Date.parse(r.endAt ?? e.endAt);
  const start = Date.parse(r.startAt ?? e.startAt);
  const ms = t.getTime();
  if (ms >= end) return "ENDED";
  if (ms >= start) return "ACTIVE";
  return "SCHEDULED";
}

/** Instants at which a status changes, sorted (SW-WS-11). */
export function transitions(rs: Timed[], e: EventPeriod): string[] {
  const set = new Set<number>();
  for (const r of rs) {
    if (r.enabled === false) continue;
    set.add(Date.parse(r.startAt ?? e.startAt));
    set.add(Date.parse(r.endAt ?? e.endAt));
  }
  return [...set].sort((a, b) => a - b).map((ms) => new Date(ms).toISOString());
}

/** First status transition strictly after `now` (SW-SY-03), `null` when nothing changes any more. */
export function nextTransition(rs: Timed[], e: EventPeriod, now: Date): Date | null {
  for (const t of transitions(rs, e)) {
    const ms = Date.parse(t);
    if (ms > now.getTime()) return new Date(ms);
  }
  return null;
}
